var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.667 25.333h-6v-16h4.667a.667.667 0 00.667-.666V4h13.333v8.667a.667.667 0 001.333 0V3.333a.666.666 0 00-.666-.666H11.334a.642.642 0 00-.256.052.66.66 0 00-.216.144L5.53 8.195a.654.654 0 00-.196.472V26c0 .368.299.667.667.667h6.666a.667.667 0 000-1.334zM7.61 8l3.057-3.057V8H7.61zm22.862 16.196a.666.666 0 00-.942-.003L24 29.69V16.667a.667.667 0 00-1.333 0v13.105l-5.613-5.579a.666.666 0 10-.94.946l6.708 6.666a.666.666 0 00.941 0l6.708-6.666a.667.667 0 00.001-.943zM8.01 17.333v-6.666h3.293l.698.625v2.483l-.758.642h-1.91v2.916H8.01zm1.323-3.966h1.301V11.75H9.333v1.616zm8.001 3.366v-5.449l-.843-.617h-3.157v6.666h3.29l.71-.6zm-1.357-.541H14.69v-4.441h1.286v4.441zm6.69-5.525v1.084H19.97v1.433h1.524v1.199H19.97v2.95h-1.303v-6.666h4z",
    fill: "#848999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.55906506078e21066c2b75e3cdd2cac3.svg";
export { ForwardRef as ReactComponent };